// Salary calculation constants
export const SALARY_CALCULATION = {
  // Valeur officielle du point d'indice au 01/01/2024
  POINT_VALUE: 4.92278,
  
  // Valeur du point d'indice au 01/01/2021 (pour calcul ISS historique)
  POINT_VALUE_2021: 4.6860,
  
  // Valeur du traitement indiciaire brut annuel de l'indice majoré 100
  // Cette constante est la base de tous les calculs de primes
  TRAITEMENT_INDICIAIRE_IM100_ANNUEL: 5907.34,
  
  // Facteurs de calcul dérivés
  TRAITEMENT_INDICIAIRE_IM100_MENSUEL: 5907.34 / 12, // 492.28 €
  
  SOCIAL_CONTRIBUTIONS_RATE: 0.22, // 22% social contributions
  TAX_ALLOWANCE_RATE: 0.10, // 10% tax allowance for professional expenses
  TAX_ALLOWANCE_MIN: 429, // Minimum tax allowance
  TAX_ALLOWANCE_MAX: 12652, // Maximum tax allowance
  MONTHS_PER_YEAR: 12,
  FULL_TIME_PERCENTAGE: 100,

  // Abattement de 1,75% appliqué à l'assiette CSG/CRDS (100% - 1,75% = 98,25%)
  CSG_CRDS_ABATTEMENT: 0.9825
} as const;

// Grade and echelon data
export interface EchelonData {
  echelon: number;
  indiceMajoré: number;
  salaireAnnuelBrut: number;
  salaireNetMensuel: number;
}

export interface GradeData {
  id: number;
  nom: string;
  description: string;
  echelons: EchelonData[];
}

export const GRADES_IDE: GradeData[] = [
  {
    id: 1,
    nom: "Grade 1 - Infirmier en soins généraux",
    description: "Grade de recrutement pour les IDE diplômés",
    echelons: [
      { echelon: 1, indiceMajoré: 395, salaireAnnuelBrut: 23334, salaireNetMensuel: 1547.25 },
      { echelon: 2, indiceMajoré: 424, salaireAnnuelBrut: 25047, salaireNetMensuel: 1660.56 },
      { echelon: 3, indiceMajoré: 447, salaireAnnuelBrut: 26406, salaireNetMensuel: 1750.42 },
      { echelon: 4, indiceMajoré: 468, salaireAnnuelBrut: 27646, salaireNetMensuel: 1832.48 },
      { echelon: 5, indiceMajoré: 491, salaireAnnuelBrut: 29004, salaireNetMensuel: 1922.34 },
      { echelon: 6, indiceMajoré: 518, salaireAnnuelBrut: 30600, salaireNetMensuel: 2027.84 },
      { echelon: 7, indiceMajoré: 550, salaireAnnuelBrut: 32490, salaireNetMensuel: 2152.87 },
      { echelon: 8, indiceMajoré: 580, salaireAnnuelBrut: 34263, salaireNetMensuel: 2270.0 },
      { echelon: 9, indiceMajoré: 610, salaireAnnuelBrut: 36035, salaireNetMensuel: 2387.3 },
      { echelon: 10, indiceMajoré: 645, salaireAnnuelBrut: 38102, salaireNetMensuel: 2524.0 },
      { echelon: 11, indiceMajoré: 678, salaireAnnuelBrut: 40052, salaireNetMensuel: 2652.99 }
    ]
  },
  {
    id: 2,
    nom: "Grade 2 - Infirmier en soins généraux et spécialisés",
    description: "Accessible après 4 ans d'ancienneté et formation spécialisée",
    echelons: [
      { echelon: 1, indiceMajoré: 427, salaireAnnuelBrut: 25224, salaireNetMensuel: 1672.28 },
      { echelon: 2, indiceMajoré: 450, salaireAnnuelBrut: 26583, salaireNetMensuel: 1762.15 },
      { echelon: 3, indiceMajoré: 478, salaireAnnuelBrut: 28236, salaireNetMensuel: 1871.55 },
      { echelon: 4, indiceMajoré: 506, salaireAnnuelBrut: 29891, salaireNetMensuel: 1980.95 },
      { echelon: 5, indiceMajoré: 534, salaireAnnuelBrut: 31545, salaireNetMensuel: 2090.35 },
      { echelon: 6, indiceMajoré: 563, salaireAnnuelBrut: 33258, salaireNetMensuel: 2203.66 },
      { echelon: 7, indiceMajoré: 593, salaireAnnuelBrut: 35031, salaireNetMensuel: 2320.88 },
      { echelon: 8, indiceMajoré: 624, salaireAnnuelBrut: 36862, salaireNetMensuel: 2442.0 },
      { echelon: 9, indiceMajoré: 656, salaireAnnuelBrut: 38752, salaireNetMensuel: 2567.0 },
      { echelon: 10, indiceMajoré: 690, salaireAnnuelBrut: 40760, salaireNetMensuel: 2699.87 },
      { echelon: 11, indiceMajoré: 727, salaireAnnuelBrut: 42946, salaireNetMensuel: 2844.44 }
    ]
  }
];

// Work time percentage options
export const WORK_TIME_OPTIONS = [
  { value: 25, label: '1/4' },
  { value: 50, label: '1/2' },
  { value: 60, label: '3/5' },
  { value: 80, label: '4/5' },
  { value: 100, label: 'Plein' }
] as const;